import TransactionCostInquiry from './transaction-cost-inquiry.vue'
export default TransactionCostInquiry
